import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

var display = function display(label1) {
  var label2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return label1 ? "<br>".concat(label2, " ").concat(label1) : '';
};

export var capitalize = function capitalize(name) {
  return name && "".concat(name[0].toUpperCase() + name.slice(1).toLowerCase());
};
export var formatAddress = function formatAddress(_ref) {
  var address = _ref.address,
      address2 = _ref.address2,
      zipcode = _ref.zipcode,
      city = _ref.city,
      countryLabel = _ref.countryLabel,
      phone = _ref.phone,
      company = _ref.company,
      comment = _ref.comment;
  return "\n  ".concat(address, "\n  ").concat(display(address2), "\n  ").concat(display(city, zipcode), "\n  ").concat(display(countryLabel), "\n  ").concat(display(phone), "\n  ").concat(display(company), "\n  ").concat(display(comment), "\n");
};
export var formatUserName = function formatUserName() {
  var civility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var firstname = arguments.length > 1 ? arguments[1] : undefined;
  var lastname = arguments.length > 2 ? arguments[2] : undefined;
  return "".concat(civility, " ").concat(capitalize(firstname), " ").concat(capitalize(lastname));
};
export var getStepperColorByShipmentStatus = function getStepperColorByShipmentStatus(label) {
  var orangeStatus = ['REQUESTING_PAYEMENT', 'APOINTEMENT'];
  var redStatus = ['CANCELED'];

  if (orangeStatus.includes(label)) {
    return 'hsl(25, 70%, 53%)';
  }

  if (redStatus.includes(label)) {
    return 'hsl(3, 61%, 46%)';
  }

  return 'hsl(84, 57%, 47%)';
};